<template>
  <transition name="el-fade-in-linear">
    <div v-if="visible && message" class="violation-ticket-tip">
      <div class="violation-ticket-tip__head">
        <span class="violation-ticket-tip__title">
          <i class="el-icon-warning-outline"></i>
          违规提醒
        </span>
        <span class="violation-ticket-tip__close el-icon-close" title="关闭" @click="close"></span>
      </div>
      <div class="violation-ticket-tip__body">{{ message }}</div>
      <div class="violation-ticket-tip__foot">
        <el-button v-if="pendingProductTotal > 0" type="text" size="mini" @click="goBatchHandle">批量处理商品</el-button>
        <el-button type="text" size="mini" @click="goList">查看列表</el-button>
      </div>
    </div>
  </transition>
</template>

<script>
function todayKey() {
  const d = new Date();
  return `${d.getFullYear()}-${d.getMonth() + 1}-${d.getDate()}`;
}

export default {
  name: "ViolationTicketTip",
  data() {
    return {
      visible: false,
      message: "",
      pendingProductTotal: 0,
      _pollTimer: null,
    };
  },
  mounted() {
    this.check();
    this._pollTimer = setInterval(() => this.check(), 5 * 60 * 1000);
  },
  beforeDestroy() {
    if (this._pollTimer) {
      clearInterval(this._pollTimer);
      this._pollTimer = null;
    }
  },
  methods: {
    dismissStorageKey() {
      const user = this.$api.getUserInfo() || {};
      const uid = user.sub_master_id || user.master_id || "0";
      return `violationTicketTipDismiss_${todayKey()}_${uid}`;
    },
    isDismissedToday() {
      return localStorage.getItem(this.dismissStorageKey()) === "1";
    },
    buildMessage(summary, productSummary) {
      const parts = [];
      if (summary.penalty > 0) {
        parts.push(`${summary.penalty} 条违规处罚`);
      }
      if (summary.risk > 0) {
        parts.push(`${summary.risk} 条风险预警`);
      }
      let msg = "";
      if (parts.length) {
        msg = `今日检测到 ${parts.join("、")}，请及时查看处理。`;
      }
      if (productSummary?.total > 0) {
        const extra = `有 ${productSummary.total} 个违规商品待批量下架/删除。`;
        msg = msg ? `${msg}${extra}` : extra;
      }
      return msg;
    },
    async check() {
      if (this.isDismissedToday()) {
        this.visible = false;
        return;
      }
      try {
        const [ticketRes, productRes] = await Promise.all([
          this.$call.invoke("SqliteDB.excute", { action: "getViolationTicketTodaySummary" }),
          this.$call.invoke("SqliteDB.excute", { action: "getViolationProductPendingSummary" }),
        ]);
        const summary = ticketRes.code === 1 ? ticketRes.data : null;
        const productSummary = productRes.code === 1 ? productRes.data : null;
        this.pendingProductTotal = productSummary?.total || 0;
        if (!summary?.total && !this.pendingProductTotal) {
          this.visible = false;
          this.message = "";
          return;
        }
        this.message = this.buildMessage(summary || {}, productSummary || {});
        this.visible = !!this.message;
      } catch (e) {
        /* ignore */
      }
    },
    close() {
      localStorage.setItem(this.dismissStorageKey(), "1");
      this.visible = false;
    },
    goList() {
      this.close();
      if (this.$route.name !== "admin_violation_ticket") {
        this.$router.push({ name: "admin_violation_ticket" });
      }
    },
    goBatchHandle() {
      this.close();
      this.$router.push({ name: "admin_violation_ticket", query: { openPending: "1" } });
    },
  },
};
</script>

<style scoped>
.violation-ticket-tip {
  position: fixed;
  left: 20px;
  bottom: 20px;
  z-index: 4999;
  max-width: 320px;
  padding: 12px 14px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 18px rgba(0, 0, 0, 0.15);
  border-left: 4px solid #f56c6c;
}

.violation-ticket-tip__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
}

.violation-ticket-tip__title {
  display: flex;
  align-items: center;
  gap: 6px;
  font-weight: 600;
  font-size: 15px;
  color: #303133;
}

.violation-ticket-tip__title i {
  color: #f56c6c;
  font-size: 18px;
}

.violation-ticket-tip__close {
  cursor: pointer;
  font-size: 16px;
  color: #909399;
  padding: 2px;
  line-height: 1;
}

.violation-ticket-tip__close:hover {
  color: #606266;
}

.violation-ticket-tip__body {
  font-size: 13px;
  color: #606266;
  line-height: 1.6;
}

.violation-ticket-tip__foot {
  margin-top: 8px;
  text-align: right;
}
</style>
